export enum DateFormats {
  'yyyy/MM' = 'yyyy/MM',
  'yyyy/MM/dd' = 'yyyy/MM/dd',
  'hh:mm:ss aa' = 'hh:mm:ss aa',
  'eee MMM d, yyyy' = 'eee MMM d, yyyy',
  'EEE, MMM d' = 'EEE, MMM d',
  'mm-dd-yyyy' = 'mm-dd-yyyy',
  'MM-dd-yyyy' = 'MM-dd-yyyy',
  'MM.dd.yyyy' = 'MM.dd.yyyy',
  'MMM dd, yyyy' = 'MMM dd, yyyy',
  'HH:mm' = 'HH:mm',
  'h:mm a' = 'h:mm a',
  'MM-dd-yyyy | h:mm a' = 'MM-dd-yyyy | h:mm a',
  'MMM dd yyyy HH:mm:ss' = 'MMM dd yyyy HH:mm:ss',
  'MM-dd-yy | h:mm a' = 'MM-dd-yy | h:mm a',
  'MM-dd-yyyy h:mm a' = 'MM-dd-yyyy h:mm a',
  'MM-dd-yyyy HH:mm:ss' = 'MM.dd.yyyy hh:mm:ss a',
  'yyyy-MM-dd HH:mm:s' = 'yyyy-MM-dd HH:mm:s',
  'yyyy-MM-dd' = 'yyyy-MM-dd',
  'MMM dd yyyy' = 'MMM dd yyyy',
  "yyyy-MM-dd'T'HH:mm:ss" = "yyyy-MM-dd'T'HH:mm:ss",
  'MM-dd-yy h:mm a' = 'MM-dd-yy h:mm a',
  'MMM d yyyy, hh:mm a' = 'MMM d yyyy, hh:mm a',
  'MMM dd yyyy, hh:mm a' = 'MMM dd yyyy, hh:mm a',
  'MMM dd yyyy | hh:mm a' = 'MMM dd yyyy | hh:mm a',
  'MM-dd-yyyy hh:mm:ss a' = 'MM-dd-yyyy hh:mm:ss a',
  'MMM d, yyyy' = 'MMM d, yyyy',
  'EEE, MMM d, yyyy' = 'EEE, MMM d, yyyy',
  'hh:mm:ss a' = 'hh:mm:ss a',
  'hh:mm a' = 'hh:mm a',
  'HH:mm:ss' = 'HH:mm:ss',
  'yyyy-MM' = 'yyyy-MM',
  'dd MMMM, yy' = 'dd MMMM, yy',
  'yyyy-Io' = 'yyyy-Io',
  'MMMM yyyy' = 'MMMM yyyy',
  'MMMM dd, yyyy' = 'MMMM dd, yyyy',
  'MM-dd-yyyy | hh:mm a' = 'MM-dd-yyyy | hh:mm a',
  'MMMM' = 'MMMM',
  'MM-dd-yy | h:mm:ss a' = 'MM-dd-yy | h:mm:ss a',
  'MM-dd-yy' = 'MM-dd-yy',
  'MMMM YYYY' = 'MMMM YYYY',
  'GGGG-[W]WW' = 'GGGG-[W]WW',
  'MM-DD-YYYY' = 'MM-DD-YYYY',
}
